import {Component, OnInit} from '@angular/core';
import { Location } from '@angular/common';
import {faLock, faShip, faUser} from '@fortawesome/free-solid-svg-icons';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AppState} from '../../../reducers';
import {Store} from '@ngrx/store';
import {selectLoginState} from '../selectors/login.selectors';
import {Observable} from 'rxjs';
import {State} from '../reducers/login.reducer';
import {loginUser} from '../actions/login.actions';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {map} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {CognitoService, IUser} from '../../../cognito.service';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-stellantis-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss']
})
export class LoginModalComponent implements OnInit {
  [x: string]: any;
  returnUrl: string;

  faShip: any = faShip;
  faUser: any = faUser;
  faLock: any = faLock;
  loginForm: FormGroup;
  loginStatus$: Observable<State>;
  isCaptchaSucceded: boolean = false;

  loading: boolean;
  user: IUser;

  // returnUrl: string;
  dynamicId: string;

  constructor(private _fb: FormBuilder,
              private store: Store<AppState>,
              private ngxService: NgxUiLoaderService,
              private router: Router,
              private route: ActivatedRoute,
              private cognitoService: CognitoService,
              public dialogRef: MatDialogRef<LoginModalComponent>,
              private location: Location
  ) {
    this.loading = false;
    this.user = {} as IUser;

    this.returnUrl = sessionStorage.getItem('returnUrl');

  }

  ngOnInit(): void {

    // this.route.queryParams.subscribe(params => {
    //   this.returnUrl = params.returnUrl;
    //   this.dynamicId = params['id'];
    // });

    this.loginStatus$ = this.store.select(selectLoginState).pipe(map(loginState => {
      if (loginState.isLogin) {
        // if (loginState.userData.role.includes('commercial_importer')) {
        //   if (this.returnUrl) {
        //     // this.router.navigate([this.returnUrl]);
        //     this.router.navigateByUrl(decodeURIComponent(this.returnUrl));
        //   } else {
        //     this.router.navigate(['/cars']);
        //   }
        //   // , {
        //   //   queryParams: { id: this.dynamicId },
        //   //   queryParamsHandling: 'merge'
        //   // });
        //   // this.router.navigate(['/cars']);
        //   // this.router.navigate([this.returnUrl]);
        // } else {
        //   if (!this.location.path().startsWith('/car-market')) {
        //     this.router.navigate(['/account/calculate']);
        //   }
        //   // this.router.navigate(['/account/calculate']);
        // }
      }
      if (loginState.loading) {
        this.ngxService.startLoader('loginLoader');
      } else {
        this.ngxService.stopLoader('loginLoader');
      }
      return loginState;
    }));
    this.loginForm = this._fb.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required]],
      recaptchaReactive: ['', [Validators.required]]
    });
  }

  login() {
    this.store.dispatch(loginUser({email: this.loginForm.value.email, password: this.loginForm.value.password}));
    this.loginStatus$.subscribe((state) => {
        if (state.isLogin) {
            this.dialogRef?.close({approve: true});
            // if (state.userData.role.includes('commercial_importer')) {
            // if (this.returnUrl) {
            //     // this.router.navigate([this.returnUrl]);
            //     this.router.navigateByUrl(decodeURIComponent(this.returnUrl));
            // } else {
            //     this.router.navigate(['/cars']);
            // }
            // } else {
            // this.router.navigate(['/account/calculate']);
            // }
        }
    });
    // this.dialogRef?.close();
  }

  register() {
    this.dialogRef?.close();
    this.router.navigate(['/auth/register']);
  }

  resetPassword() {
    this.dialogRef?.close();
    this.router.navigate(['/auth/forget']);
  }

  resolved(captchaResponse: string) {
    // debugger;
    console.log(`Resolved response token: ${captchaResponse}`);
    if (captchaResponse.length > 0) {
      this.isCaptchaSucceded = true;
    }

  }

}
